import { BlocksIconHide } from 'blocks-nextjs/blocks-web-components/components/icon/icons/hide';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconHide = createComponent({ react: React, tagName: 'cat-icon-hide', elementClass: BlocksIconHide });
